import React from "react";
import { motion } from "framer-motion";
import { Box, Container, Typography } from "@mui/material";
import ACICN from "../../assets/icons/HomeAssistance/AC.png";
import CHIMNEYICN from "../../assets/icons/HomeAssistance/Chimney.png";
import FOODPROCESSORICN from "../../assets/icons/HomeAssistance/Food processor.png";
import FRIDGESICN from "../../assets/icons/HomeAssistance/Fridge.png";
import GEYSERICN from "../../assets/icons/HomeAssistance/Geyser.png";
import MICROWAVESICN from "../../assets/icons/HomeAssistance/Microwave.png";
import TVICN from "../../assets/icons/HomeAssistance/TV.png";
import VACCUMCLEANERICN from "../../assets/icons/HomeAssistance/Vacuum Cleaner.png";
import WASHINGMACHINEICN from "../../assets/icons/HomeAssistance/WashingMachine.png";
import WATERPURIFIERICN from "../../assets/icons/HomeAssistance/Water Purifier.png";
const CoverAppliances = () => {
    const scrollAnimation = {
        initial: { x: "0%" },
        animate: { x: "-50%" },
        transition: {
            repeat: Infinity,
            duration: 25,
            ease: "linear",
        },
    };

    const COVERED_APPLIANCES_LIST = [
        { icon: FRIDGESICN, title: "Fridge" },
        { icon: ACICN, title: "AC" },
        { icon: WASHINGMACHINEICN, title: "Washing Machine" },
        { icon: MICROWAVESICN, title: "Microwave" },
        { icon: TVICN, title: "TV" },
        { icon: WATERPURIFIERICN, title: "Water Purifier" },
        { icon: GEYSERICN, title: "Geyser" },
        { icon: CHIMNEYICN, title: "Chimney" },
        { icon: VACCUMCLEANERICN, title: "Vacuum Cleaner" },
        { icon: FOODPROCESSORICN, title: "Food processor" },
    ];

    const renderCards = (items) =>
        items.map((benefit, index) => (
            <Box key={index + benefit.title} elevation={1} sx={styles.CardContainer}>
                <Box sx={styles.CardImgContainer}>
                    <img
                        src={benefit?.icon}
                        alt={benefit?.title}
                        style={styles.AppliancesIcons}
                    />
                </Box>

                <Box sx={styles.TitleTxtContainer}>
                    <Typography variant="h6" sx={styles.TitleTxt}>
                        {benefit?.title}
                    </Typography>
                </Box>
            </Box>
        ));

    return (

        <Box sx={{ bgcolor: "#fff6f1", py: 4 }}>
            <Container maxWidth="lg">
                <Box align="center">
                    {/* <Heading title="Appliances We Covered" /> */}
                    <Typography
                        variant="h4" className="main-heading-font-size " >
                        Appliances We Covered
                    </Typography>
                </Box>
                <Box sx={{ overflow: "hidden", py: 4 }}>
                    <motion.div
                        style={{
                            display: "flex",
                            width: "fit-content",
                        }}
                        {...scrollAnimation}
                    >
                        {/* Duplicate the list for seamless loop */}
                        {renderCards(COVERED_APPLIANCES_LIST)}
                        {renderCards(COVERED_APPLIANCES_LIST)}
                    </motion.div>
                </Box>
            </Container>
        </Box>
    );
};

export default CoverAppliances;

const styles = {
    CardImgContainer: {
        textAlign: "center",
        background: "linear-gradient(180deg, #fafcff, #e9f4fe)",
        mx: 1,
        width: 110,
        height: 110,
        flexShrink: 0, // prevent shrinking during scroll
        borderRadius: 110,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    TitleTxtContainer: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    CardContainer: {
        // borderRadius: 4,
        // textAlign: "center",
        mx: 1,
        // width: 110,
        // minWidth: 110,
        // flexShrink: 0, // prevent shrinking during scroll
    },
    AppliancesIcons: {
        marginTop: 8,
        width: "100%",
        height: "50px",
        objectFit: "contain",
    },
    TitleTxt: {
        fontWeight: 500,
        fontSize: "0.9rem",
        mt: 3,
        mb: 1,
        fontFamily: '"Poppins", serif',
    },
};
